import { useEffect, useState } from "react";
import { auth } from "@/integrations/firebase/client";
import { onAuthStateChanged } from "firebase/auth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

export const RequireAuth = () => {
  const location = useLocation();
  const [ready, setReady] = useState(false);
  const [isAuthed, setIsAuthed] = useState<boolean>(!!auth.currentUser);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setIsAuthed(!!u);
      setReady(true);
    });
    return () => unsub();
  }, []);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!isAuthed) return <Navigate to="/auth" replace state={{ from: location }} />;
  return <Outlet />;
};

export const PublicOnly = () => {
  const location = useLocation();
  const [ready, setReady] = useState(false);
  const [isAuthed, setIsAuthed] = useState<boolean>(!!auth.currentUser);
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setIsAuthed(!!u);
      setReady(true);
    });
    return () => unsub();
  }, []);
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  // If already authenticated, redirect to the originally intended page (if any), otherwise to the editor
  if (isAuthed) {
    const from = (location.state as any)?.from?.pathname as string | undefined;
    return <Navigate to={from || "/editor"} replace />;
  }
  return <Outlet />;
};

export default RequireAuth;


